module.exports = __webpack_public_path__ + "img/logo.2a6f1171.svg";